import React, { Component } from 'react'
import Add from 'material-ui/svg-icons/content/add'
import Record from 'material-ui/svg-icons/action/record-voice-over'
import Delete from 'material-ui/svg-icons/action/delete'
import Tv from 'material-ui/svg-icons/hardware/tv'
import Toys from 'material-ui/svg-icons/hardware/toys'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import Snackbar from 'material-ui/Snackbar'
import Table from '../../components/Table'
import SeminarTabs from '../../components/SeminarTabs'
import Modal from './Modals'
import Timer from '../../components/Timer'
import ReactTooltip from 'react-tooltip'
import { checkJapanese } from '../../lib/lib'

class BreakOut extends Component {
  constructor (props) {
    super(props)
    this.state = {
      snackbarOpen: false,
      snackbarMessage: '',
      listModalOpen: false,
      listModalPurpose: null,
      showSeminarMode: false,
      tableLock: null,
      move_name: '',
      move_uid: '',
      move_user_id: '',
      move_group: '',
      move_table: '',
      move_role: '',
      move_direct: false
    }
  }

  handleTouchTap = (e, message) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message
    })
  }

  handleRequestClose = () => {
    this.props.handleRequestClose()
    this.setState({snackbarOpen: false})
  }

  handleListModalClose = () => this.setState({listModalOpen: false})
  handleListClick = (e, purpose, arg1, arg2, arg3, arg4, arg5) => {
    if (purpose == 'move') {
      this.setState({move_uid: arg1, move_name: arg2, move_user_id: arg3, move_role: arg4, move_direct: arg5})
      var find_flag = false
      this.props.groupList.map((user) => {
        if (user.uid == arg1) {
          find_flag = true
          this.setState({move_group: user.group})
          if (user.group == 0) {
            this.setState({move_table: 'no assigned'})
          } else {
            var obj = this.props.tableList.filter(
              table => table['group'] === user.group
            )
            this.setState({move_table: `in ${obj[0].name}`})
          }
        }
      })
      if (!find_flag) {
        this.setState({move_group: 0, move_table: 'no assigned'})
      }
    }
    this.setState({listModalOpen: true, listModalPurpose: purpose})
  }

  editTableLock = (flag, TableNum) => {
    if (flag) {
      this.setState({tableLock: TableNum})
    } else {
      this.setState({tableLock: null})
    }
  }

  checkTableName = (name, TableNum) => {
    var return_val = false
    if (this.props.tableList) {
      this.props.tableList.map((val, index) => {
        if (val.name == name) {
          return_val = true
        }
      })
    }
    return return_val
  }

  render () {
    return (
      <div className='flex' style={{height: '91vh'}}>
        <div className='w-75 flex flex-column dib'>
          <div className='vh-75 overflow-y-auto overflow-x-hidden flex justify-center ml5'>
            <div className='w-80 pt3 flex flex-wrap' style={{width: '60vw'}}>
              {this.props.tableList && this.props.tableList.map((val, index) => (
                <Table
                  key={(this.state.tableLock == val.group) ? null : Math.floor(Math.random() * 100000)}
                  editTable={this.props.editTable}
                  checkTableName={this.checkTableName}
                  editTableLock={this.editTableLock}
                  editTableStatus={(this.state.tableLock == val.group)}
                  index={index} group={val.group}
                  name={val.name}
                  location={this.props.location}
                  user_role={this.props.role}
                  direct={this.props.direct}
                  user_name={this.props.user_name}
                  user_uid={this.props.user_uid}
                  user_id={this.props.user_id}
                  joinVideo={this.props.joinVideo}
                  groupListObj={this.props.groupListObj}
                  onHear={this.props.onHear}
                  hear={this.props.hear}
                />
              ))}
              {false && <Table index={4} full/>}
              {false && <Table index={5} empty/>}
            </div>
          </div>
          <div
            className='w-100 bg-white flex justify-between'
            style={{height: 117, borderTop: '1px solid #1C79D2'}}>
            <Timer/>
            {this.props.role != 'student' && <div className='flex items-center mr7'>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                   ${(checkJapanese()) ? `
                      セミナーモードへ
                      ` : `
                      Go to Seminar Mode
                    `}
                </div>`}
                onClick={(e) => this.handleListClick(e, 'return')}
                backgroundColor='#29B87A'
                className='ml3 mr3 float-flat-button'
                style={{width: 100, borderRadius: '40px'}}>
                <Tv/>
              </FloatingActionButton>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                  <div
                    class='pb2 custom-tooltip'>
                    ${(checkJapanese()) ? `
                      テーブルの作成
                      ` : `
                      Create New Table
                    `}
                  </div>`}
                onClick={(e) => this.handleListClick(e, 'create')}
                className='ml2 mr2'>
                <Add/>
              </FloatingActionButton>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                  <div
                    class='pb2 custom-tooltip'>
                    ${(checkJapanese()) ? `
                      メッセージの全体送信
                      ` : `
                      Send Announce Message
                    `}
                  </div>`}
                onClick={(e) => this.handleListClick(e, 'announce')}
                className='ml2 mr2'>
                <Record/>
              </FloatingActionButton>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                  <div
                    class='pb2 custom-tooltip'>
                    ${(checkJapanese()) ? `
                      受講者のランダム割り当て
                      ` : `
                      Random Assign
                    `}
                  </div>`}
                onClick={(e) => this.handleListClick(e, 'randomAssign')}
                className='ml2 mr2'>
                <Toys/>
              </FloatingActionButton>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                  <div
                    class='pb2 custom-tooltip'>
                    ${(checkJapanese()) ? `
                      テーブルの削除
                      ` : `
                      Delete Table
                    `}
                  </div>`}
                onClick={(e) => this.handleListClick(e, 'delete')}
                className='ml2 mr2'>
                <Delete/>
              </FloatingActionButton>
            </div>}
          </div>
        </div>
        <div className='w-25'>
          <SeminarTabs location={this.props.location} mode={'breakout'} user_role={this.props.role}
                       remoteList={this.props.remoteList} handleListClick={this.handleListClick}
                       handleChat={this.props.handleChat} groupList={this.props.groupList} chat={this.props.chat}/>
        </div>
        <Snackbar
          style={{left: 200, bottom: 30}}
          open={(this.props.snackbarOpen) ? (this.props.snackbarOpen) : (this.state.snackbarOpen)}
          message={(this.props.snackbarOpen) ? (this.props.snackbarMessage) : (this.state.snackbarMessage)}
          action='dismiss'
          onActionClick={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />
        <Modal
          redirectToSeminarMode={this.props.redirectToSeminarMode}
          randomHandle={this.props.randomHandle}
          purpose={(this.props.listModalOpen) ? (this.props.listModalPurpose) : (this.state.listModalPurpose)}
          open={(this.props.listModalOpen) ? (this.props.listModalOpen) : (this.state.listModalOpen)}
          handleClose={this.handleListModalClose}
          snackbarOpen={this.handleTouchTap}
          createTable={this.props.createTable}
          deleteTable={this.props.deleteTable}
          tableList={this.props.tableList}
          joinVideo={this.props.joinVideo}
          name={this.props.name}
          handleChat={this.props.handleChat}
          groupListObj={this.props.groupListObj}
          move_uid={this.state.move_uid}
          move_user_id={this.state.move_user_id}
          move_name={this.state.move_name}
          move_group={this.state.move_group}
          move_table={this.state.move_table}
          move_role={this.state.move_role}
          move_direct={this.state.move_direct}
        />
      </div>
    )
  }
}

export default BreakOut



// WEBPACK FOOTER //
// ./src/routes/BreakOutMode/BreakOutMode.js